module.exports = __webpack_public_path__ + "img/Windows_logo_-_2012.a1167ce7.svg";